import { render, staticRenderFns } from "./BaseSearchPage.vue?vue&type=template&id=0dfc3540&scoped=true&"
import script from "./BaseSearchPage.vue?vue&type=script&lang=js&"
export * from "./BaseSearchPage.vue?vue&type=script&lang=js&"
import style0 from "./BaseSearchPage.vue?vue&type=style&index=0&id=0dfc3540&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dfc3540",
  null
  
)

export default component.exports